import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-plotly-bar',
  templateUrl: './plotly-bar.component.html',
  styleUrls: ['./plotly-bar.component.css']
})
export class PlotlyBarComponent implements OnInit, OnChanges{
  @ViewChild("bar", { static: true })
  private _bar: ElementRef;
  @Input() index:any;
  @Input() barData: any;
  @Input() paperBgColor: string = '#f6f6f6';
  @Input() plotBgColor: string = '#f6f6f6';
  private _className:any;
  constructor() { }

  ngOnInit(): void { }  

  ngOnChanges(){
    // if(this.barData?.length)
    // this.plotGraph();
    if(this.barData.length)
    setTimeout(() => {
    this._plotGraph();
    },0);
  }
  private _plotGraph(){
    this._className = 'bar'+ JSON.stringify(this.index);
    window.Plotly.newPlot( 
      this._bar.nativeElement, //viewchild element
      this.barData, //data provided
      { 
      height: this.barData[0].barHeight?this.barData[0].barHeight: 250,
      width: this.barData[0].barWidth?this.barData[0].barWidth: 300,
      margin: this.barData[0].margin,
      title: this.barData[0].title, //Title of the graph
      hovermode: "closest",
      //hoverinfo: this.barData[0].hoverinfo,
      showlegend: this.barData[0].showlegend? this.barData[0].showlegend: false,
      yaxis: {fixedrange: true,
        tickangle: -45,
        showgrid: this.barData[0].showgrid, 
        zeroline: this.barData[0].zeroline,
        visible: this.barData[0].visible,
        showticklabels: this.barData[0].showticklabels      },
      xaxis : {fixedrange: true,
        range: this.barData[0].range,
        showgrid: this.barData[0].showgrid, 
        zeroline: this.barData[0].zeroline,
        visible: this.barData[0].visible,
        showticklabels: this.barData[0].showticklabels
      },
      barmode: this.barData[0].barmode,
      dragmode: false,
      paper_bgcolor: this.barData[0].barColor? this.barData[0].barColor: "#f6f6f6",
      plot_bgcolor: this.barData[0].barColor?this.barData[0].barColor : "#f6f6f6",
      font:{
        size:10
      }
      },
      { //this is where the configuration is defined
      responsive: true,
      displaylogo: false,
      scrollZoom: true,
      displayModeBar: false,
      });
  }

}
